'use client';

import SearchBar from 'components/controls/search-bar';
import { useRouter } from 'src/navigation';
import { useState } from 'react';
const SEARCH_PAGE = `/met-publications/all`;

const PublicationLandingPageSearchWrapper = () => {
	const [query, setQuery] = useState(null);
	const router = useRouter();

	const handleSearch = () => {
		query ? router.push(`${SEARCH_PAGE}?q=${query}`) : router.push(SEARCH_PAGE);
	};

	return (
		<SearchBar
			debounceTimeout={0}
			placeholderText="Type to search&hellip;"
			onKeyDown={(event) => event.key === 'Enter' && handleSearch()}
			onChange={(event) => setQuery(event.target.value)}
			onButtonClick={handleSearch}
		/>
	);
};

export default PublicationLandingPageSearchWrapper;
